import axios from "axios";

const { searchRoutes } = require("../../constants/Routes");

export const searchUser = async (query) => {
	try {
		let response = await axios.get(`${searchRoutes.searchUser}/${query}`, {});
		return response.data;
	} catch (err) {
		console.log(err);
		return {};
	}
};

export const searchCredential = async (
	credential_no,
	language,
	url,
	referrerUrl,
	viewerId
) => {
	try {
		let response = await axios.post(searchRoutes.searchCredential, {
			credential_no: credential_no,
			language: language,
			referrer_url: referrerUrl,
			user_id: viewerId,
		});
		return response.data;
	} catch (err) {
		console.log(err);
		return {};
	}
};

export const getPreviewWithDeliveryId = async (
	delivery_id,
	language,
	url,
	certNo
) => {
	try {
		let response = await axios.post(searchRoutes.credentialPreview, {
			deliveryId: delivery_id,
			language: language,
			certificateNo: certNo,
		});
		return response.data;
	} catch (err) {
		console.log(err);
		return {};
	}
};

export const getSingleUser = async (email) => {
	try {
		let response = await axios.post(searchRoutes.getSingleUser, {
			query: email,
		});
		return response;
	} catch (error) {
		console.log(error);
		return null;
	}
};
